var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.87 34.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.92,32.17c0,1.53-.88,2.57-2.27,2.69-1.45,.13-2.66-.96-2.69-2.5-.03-1.56,0-3.1,0-4.67,0-2.37,0-4.74,0-7.12,0-.19,0-.38-.01-.75-.28,.04-.49,.09-.7,.09-3.83,.01-7.67,0-11.5,.01-1.1,0-1.98-.4-2.48-1.41-.81-1.63,.36-3.51,2.23-3.56,1.99-.04,3.97,0,5.96,0,2.14,0,4.28,0,6.48,0,0-.23,.03-.44,.02-.64,0-3.87,0-7.74,0-11.61,0-1.09,.4-1.94,1.38-2.44,1.48-.77,3.31,.18,3.55,1.84,.04,.27,.04,.54,.04,.81,0,3.77,0,7.54,0,11.33,0,.21-.06,.42-.11,.68,.38,.01,.61,.03,.83,.03,3.87,0,7.74,0,11.62,0,1.6,0,2.72,1.15,2.61,2.64-.08,1.24-1.03,2.21-2.3,2.3-.58,.04-1.17,.02-1.75,.02-3.61,0-7.2,0-10.88,0,0,.25-.02,.47-.02,.69,0,3.86,0,7.71,0,11.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset 9.8dad68fb12939bfd8a84deaa5293e90c.svg";
export { ForwardRef as ReactComponent };